<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<p-table #pt [value]="changeHistoryList" selectionMode="single"
  [loading]="loading" [paginator]="true" [rows]="25"
  [rowsPerPageOptions]="[25,100,200]" showCurrentPageReport="true"
  sortMode="multiple" styleClass="p-datatable-striped"
  [resizableColumns]="true" [autoLayout]="true" [responsive]="true"
  currentPageReportTemplate="Showing {first} to {last} of {totalRecords} records">

  <ng-template pTemplate="caption">
    <div class="d-block text-end justify-content-between align-items-center">
      <span>
        <!--clear filters-->
        <button pButton pRipple class="p-button-text"
          style="font-size: 80%; padding: 0.643rem 0.75rem !important; margin-right:10px;"
        (click)="reloadPage()">Clear Filters</button>
      </span>
    </div>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      @for (col of columns; track col) {
        <th [pSortableColumn]="col.field" [ngStyle]="{'width': 'auto'}">
          {{col.header}}
          <p-sortIcon [field]="col.field"></p-sortIcon>
        </th>
      }
      <th [ngStyle]="{'width': 'auto'}"></th>
    </tr>
    <tr>
      @for (col of columns; track col) {
        <th [ngStyle]="{'width': 'auto'}">
          <input pInputText type="text" [ngStyle]="{'width':'50px','min-width':'100%'}" (input)="pt.filter($event.target.value, col.field, 'contains')" style="width: 100%">
        </th>
      }
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-res>
    <tr>
      <td> {{ res.commitId | number:'1.0-0'}} </td>
      <td> {{ res.author }} </td>
      <td> {{ res.commitDate | date:'MM-dd-yyyy HH:mm'}} </td>
      <td> {{ res.commitDateInstant | date:'MM-dd-yyyy HH:mm'}} </td>
      <td> {{ res.version}} </td>
      <td> {{ res.type}} </td>
      <td> {{ res.changedProperties}} </td>
      <td> {{ res.state }} </td>
      <td> {{ res.localId }} </td>
      <td> {{ res.typeName}} </td>
    </tr>
  </ng-template>
</p-table>